module.exports = __webpack_public_path__ + "04_long_black.34d5a227.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_long_black.png
// module id = WVYG
// module chunks = 0